import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";
import { analytics } from '../utils/analytics';

const Banner = () => {
  const handleSocialClick = (platform) => {
    analytics.socialMedia.socialMediaClick(platform);
  };

  return (
    <section
      className="d-flex align-items-center justify-content-center py-5"
      style={{ minHeight: "60vh" }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Image on the left for md and up, on top for mobile */}
          <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
            <img
              src="/mohonish.jpg"
              alt="Your Name"
              className="rounded-circle"
              style={{
                width: "200px",
                height: "200px",
                objectFit: "cover",
                border: "4px solid var(--bs-primary, #ff6600)",
              }}
            />
          </div>
          {/* Tagline and buttons */}
          <div className="col-12 col-md-7 text-center">
            <p className="mb-4 fs-4" style={{ color: "#fff" }}>
              Software Craftsman & Creative Catalyst
            </p>
            {/* <div>
              <a href="#projects" className="btn btn-primary me-3 mb-2 mb-md-0">
                View Projects
              </a>
              <a href="#contact" className="btn me-3 btn-outline-light mb-2 mb-md-0">
                Contact Me
              </a>
            </div> */}
            {/* Social Media Icons */}
            <div className="d-flex justify-content-center gap-3">
              <a 
                href="https://www.linkedin.com/in/mohonish-mullick-24756a55/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ color: "#0d6efd", fontSize: "2rem" }}
                onClick={() => handleSocialClick('linkedin')}
              >
                <FaLinkedin />
              </a>
              <a 
                href="https://www.instagram.com/bhuttushows/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ color: "#0d6efd", fontSize: "2rem" }}
                onClick={() => handleSocialClick('instagram')}
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/mohonish.mullick" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ color: "#0d6efd", fontSize: "2rem" }}
                onClick={() => handleSocialClick('facebook')}
              >
                <FaFacebook />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
